import type { OptionGroupAPIData } from 'domains/option_groups';
import type { CustomProductTemplateAPIData, ProductTemplateAPIData } from 'types/catalog_types';
import type { Dictionary, Dimension, LoadingStatus, OptionalPair, Point } from 'types/common_types';

export type CanvasesSliceInitialState = {
  active: string | null;
  activeLock: boolean;
  arrangementPosition: Point;
  nextCanvasPosition: number;
  status: LoadingStatus;
  /**
   * undefined: Not on custom size
   * 0 - currently pending both product & option success or both error
   * 1 - one is successful, pending or error on other
   * 2 - both successful
   */
  priceFetchSuccessCount?: 0 | 1 | 2;
};

export type CanvasConfiguration = {
  id: string;
  catalog?: number;
  subcatalog?: number;
  product?: number;
  options?: CanvasOptionConfiguration;
  height?: number;
  width?: number;
  cartProductId?: number;
  text_nodes_json?: string;
  customPrice?: string;
  customOptionPrices?: Record<string, string>;
  rotation: number;
  userRotated: boolean;
  /** 8 character Hex value */
  borderColor?: string;
  position: Point;
};

export type CanvasOptionConfiguration = Dictionary<number>;

export type ConfigChange = Pick<CanvasConfiguration, 'catalog' | 'subcatalog' | 'product'>;

export type CanvasOptionChangePayload = {
  options: OptionalPair<number, number>[];
  /** Replace entire option set */
  replace?: boolean;
};

export type CanvasMovementPayload = {
  id?: string;
  movementX: number;
  movementY: number;
  leftLimit?: number;
  rightLimit?: number;
  bottomLimit?: number;
  topLimit?: number;
};

export type NextSizePayload = {
  product: ProductTemplateAPIData;
  printX: number;
  printY: number;
  width: number;
  height: number;
  rotate: boolean;
};

export type CustomSizePayload = {
  height?: number;
  width?: number;
};

export type CustomSizePricePayload = {
  size: Dimension;
  billingCode: string;
};

export type CustomSizeOptionPayload = {
  size: Dimension;
  optionGroups: OptionGroupAPIData[];
  configuredOptions: CanvasOptionConfiguration;
};

export type PriceToolSizePayload = {
  product: number;
  height: number;
  width: number;
};
